import App from "@/App.vue";
import "@/firebase";
import "@/registerServiceWorker";
import LoadingApp from "@/LoadingApp.vue";
import { AppI18n } from "@/common/plugins/i18n";
import { AppVuetify } from "@/common/plugins/vuetify";
import { AppRouter } from "@/common/router";
import { authService } from "@/common/services/AuthService";
import "@mdi/font/css/materialdesignicons.css";
import firebase from "firebase/app";
import "firebaseui/dist/firebaseui.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./globalComponents.js";
import Vue, { VNode, VueConstructor } from "vue";
import { userService } from "@/common/services/UserService";
import { storeService } from "@/common/services/StoreService";
import FirebaseSignIn from "@/common/components/FirebaseSignIn.vue";

Vue.config.productionTip = false;

let app: Vue | undefined;

function mountAppComponent(appComponent: VueConstructor): void {
  app?.$destroy();
  app = new Vue({
    router: AppRouter,
    vuetify: AppVuetify,
    i18n: AppI18n,
    render: (h): VNode => h(appComponent),
  }).$mount("#app");
}

function mountLoadingApp(): void {
  app?.$destroy();
  app = new Vue({
    vuetify: AppVuetify,
    i18n: AppI18n,
    render: (h): VNode => h(LoadingApp),
  }).$mount("#app");
}

mountLoadingApp();

firebase.auth().onAuthStateChanged(async (user) => {
  if (user) {
    mountLoadingApp();
    const userID = user.uid;
    const refreshToken = user.refreshToken;
    const { token, claims, expirationTime } = await user.getIdTokenResult(true);

    authService.setState({
      claims,
      expirationTime,
      refreshToken,
      token,
      userID,
    });

    await userService.collectUser();
    await storeService.collectStores();
    mountAppComponent(App);
  } else {
    authService.clearState();
    mountAppComponent(FirebaseSignIn);
  }
});
